import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import TextLink from '../../atoms/link/Textlink';
import {
  makeAdditionalParamsPlanList,
  makeQueryStringsWithDuplicatedSessionKey,
} from '../../../utils/queryParams';
import { BASENAME, STATIC_DPP_TOP_URL } from '../../../constants';

const separator = (
  <span className="separator">{'>'}</span>
);

const dppTopLink = (
  <TextLink to={STATIC_DPP_TOP_URL}>日本旅行トップ</TextLink>
);

const tourLink = (
  <TextLink to={`${STATIC_DPP_TOP_URL}/kokunai/`}>国内旅行・国内ツアー</TextLink>
);

const setPlanLink = (
  <TextLink to={`${STATIC_DPP_TOP_URL}/kokunai/special/air/`}>航空+宿泊セットプラン</TextLink>
);

const searchLinkText = '検索結果';
const SearchLink = ({ disable }) =>  disable ? searchLinkText : (
  <TextLink to={`${BASENAME}/search`}>{searchLinkText}</TextLink>
);
SearchLink.propTypes = { disable: PropTypes.bool };

const planLinkText = '施設プラン一覧';
const PlanListLink = ({ disable, to }) =>  disable ? planLinkText : (
  <TextLink to={to || `${BASENAME}/plan_list`}>{planLinkText}</TextLink>
);
PlanListLink.propTypes = { disable: PropTypes.bool, to: PropTypes.string };

const planDetailText = 'プラン詳細';

const selector = (state) => ({
  planDetail: state.planDetail,
});

const Breadcrumb = () => {
  const { planDetail } = useSelector(selector);
  const { plans } = planDetail;
  const plan = plans && !!plans.length ? plans[0].plan : undefined;

  const location = useLocation();
  const { pathname } = location;
  let children = null;
  switch (pathname) {

  case '/search': {
    children = (
      <SearchLink disable />
    );
    break;
  }

  case '/searcha': {
    children = (
      <React.Fragment>
        <SearchLink />
        {separator}
        <PlanListLink disable />
      </React.Fragment>
    );
    break;
  }

  case '/plan_list': {
    children = (
      <React.Fragment>
        <SearchLink />
        {separator}
        <PlanListLink disable />
      </React.Fragment>
    );
    break;
  }

  case '/plan_detail': {
    const hotelId = plan && plan.hotel && plan.hotel.id;
    const paramsPlanList = makeAdditionalParamsPlanList(hotelId);
    const handlePlanListLinkClick = () => {
      const search = makeQueryStringsWithDuplicatedSessionKey(paramsPlanList);
      const planListLink = `${BASENAME}/plan_list?${search}`;
      window.open(planListLink, '_self');
    };
    children = (
      <React.Fragment>
        <SearchLink />
        {separator}
        <TextLink onClick={handlePlanListLinkClick}>{planLinkText}</TextLink>
        {separator}
        {planDetailText}
      </React.Fragment>
    );
    break;
  }

  default: {
    break;
  }
  }

  if (!children) {
    return null;
  }

  return (
    <div className="breadcrumb">
      <div className="breadcrumbContainer">
        {dppTopLink}
        {separator}
        {tourLink}
        {separator}
        {setPlanLink}
        {separator}
        {children}
      </div>
    </div>
  );
};

Breadcrumb.propTypes = {
};

export default Breadcrumb;

